import WarningDialog from './WarningDialog';

export default WarningDialog;
